import React, { FC, ReactNode } from 'react';
import styles from './Container.css';
import { clsx } from 'clsx';

interface IContainerProps {
  children: ReactNode;
  dataName?: string;
  className?: string;
  margin?: number;
}

export const Container: FC<IContainerProps> = ({ children, dataName, className }) => (
  <div className={clsx(styles['container'], className)} data-name={dataName}>
    {children}
  </div>
);
